import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["show", "unchecked", "background", "borderColor", "hideConnector", "customConnector", "className", "children"];
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { AnimatePresence, motion } from 'framer-motion';
import RuleConnector from './RuleConnector';
var RuleContainer = function RuleContainer(props) {
  var show = props.show,
    unchecked = props.unchecked,
    background = props.background,
    borderColor = props.borderColor,
    hideConnector = props.hideConnector,
    customConnector = props.customConnector,
    className = props.className,
    children = props.children,
    remainingProps = _objectWithoutProperties(props, _excluded);
  if (!show) {
    return null;
  }
  var boxClassNames = classNames('RuleContainerBox', 'position-relative', 'rounded padding-20', background, unchecked && "border border-width border-style-dashed ".concat(borderColor), className);
  return /*#__PURE__*/React.createElement("div", _extends({
    className: "RuleContainer"
  }, remainingProps), /*#__PURE__*/React.createElement("div", {
    className: boxClassNames,
    "data-testid": "ruleContainerBox"
  }, /*#__PURE__*/React.createElement(AnimatePresence, {
    exitBeforeEnter: true
  }, React.Children.map(children, function (child) {
    var _child$type;
    if (!child) {
      return null;
    }

    // In case there are multiple children of RuleContainer, use the
    // type name or the type itself as a key to animate between the two children
    return /*#__PURE__*/React.createElement(motion.div, {
      key: ((_child$type = child.type) === null || _child$type === void 0 ? void 0 : _child$type.name) || child.type,
      initial: {
        opacity: 0
      },
      animate: {
        opacity: 1
      },
      exit: {
        opacity: 0
      }
      // transition={{ delay: 1, duration: 2 }}
    }, child);
  }))), customConnector ? customConnector : /*#__PURE__*/React.createElement(RuleConnector, {
    hidden: unchecked || hideConnector
  }));
};
RuleContainer.defaultProps = {
  show: true,
  unchecked: false,
  background: 'bg-lightest',
  borderColor: '',
  hideConnector: false,
  className: ''
};
RuleContainer.propTypes = {
  show: PropTypes.bool,
  unchecked: PropTypes.bool,
  background: PropTypes.string,
  borderColor: PropTypes.string,
  hideConnector: PropTypes.bool,
  customConnector: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  className: PropTypes.string
};
export default RuleContainer;